import { MenuItemIcon } from '@/components/MenuItem/MenuItemIcon';
import BringToFront from '@/images/position/ToFront.svg';
import { useAdvancedEditorContext } from '@/pages/AdvancedEditor/context/useAdvancedEditorContext';
import { bringElementsToFront } from '../../../../actions/arrange/BringToFront';

interface Props {
    disabled: boolean;
}

export const BringToFrontMenuItem = ({ disabled }: Props) => {
    const { store } = useAdvancedEditorContext();
    const selectedElements = store.selectedElements;

    const handleClick = () => {
        bringElementsToFront(store, selectedElements);
    };

    return <MenuItemIcon disabled={disabled} onClick={handleClick} src={BringToFront} text="Bring to front" />;
};
